/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Sales
 *
 * 2 = Service
 *
 * 3 = Template
 */
export enum VideoLogCustomerTypes {
  Sales = 1,
  Service = 2,
  Template = 3,
}
